<mat-form-field appearance="outline" *im2mLet="loading$ | async as loading">
    <mat-label>{{ 'USERS.TENANT' | transloco }}</mat-label>
    <input matInput class="filter-input" [formControl]="tenantFilterCtrl" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" (focus)="onFocus(menuTrigger)" required />
    <mat-error *ngIf="tenantFilterCtrl.hasError('required')">
        {{ 'FORM_ERRORS.REQUIRED' | transloco }}
    </mat-error>

    <mat-menu #menu class="tenant-list-menu-container">
        <div class="available-tenants">
            <h3 class="list-title">{{ 'TENANTS.AVAILABLE' | transloco }}</h3>
            <div class="table-container" (click)="$event.stopPropagation()">
                <liebherr-loading *ngIf="loading === true"></liebherr-loading>
                <table mat-table [dataSource]="tenantSource">
                    <ng-container *ngFor="let column of tenantColumns" [matColumnDef]="column">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'TENANTS.NAME' | transloco }}
                        </th>
                        <td mat-cell class="selectable" *matCellDef="let element" (click)="onSelection(element, menuTrigger)">
                            {{ element.name || '-' }}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="tenantColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: tenantColumns"></tr>
                </table>
                <liebherr-no-data *ngIf="tenantSource.data.length === 0 && !loading"></liebherr-no-data>
            </div>
            <mat-paginator #paginator (click)="$event.stopPropagation()" [pageSizeOptions]="[5]" [pageSize]="5"></mat-paginator>
        </div>
    </mat-menu>
</mat-form-field>
<span class="hint positiv" *ngIf="tenantWillBeCreated$ | async">{{ 'TENANTS.CREATE_NEW_TENANT_HINT' | transloco }}</span>
